import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
const SubCasino = ({ header, subCasino, setSubCasino, subCasinoTrue }) => {
  const live = [
    "SEXY",
    "EVO",
    "PT",
    "PP",
    "BG",
    "HOTROAD",
    "VIACASINO",
    "WINFINITY",
    "CREEDROOMZ",
  ];
  const table = [
    "KINGMAKER",
    "NETENT",
    "JILI",
    "JDB",
    "PG",
    "RT",
    "ROYALGAMING",
  ];
  const slot = [
    "PP",
    "KINGMAKER",
    "YESBINGO",
    "DRAGOONSOFT",
    "SPADE",
    "NETENT",
    "PT",
    "MICROSLOT",
    "JDB",
    "FC",
    "JILI",
    "PG",
    "FASTSPIN",
    "RT",
  ];
  const fishing = ["SPADE", "JDB", "JILI", "YESBINGO", "FC", "YL", "FASTSPIN"];
  const egame = ["SPRIBE", "SMARTSOFT", "PP", "JDB", "YL", "YESBINGO"];
  const awc = ["BG", "BTG", "NLC", "RT", "YesBingo"]; //remove E1SPORT,YL,SV388
  const crash = [
    "SMARTSOFT",
    "BGAMING",
    "GEMINI",
    "PASCAL",
    "JILI",
    "KINGMAKER",
    "PP",
    "EG",
    "MG",
  ];
  const royal = ["INOUT", "BGAMING", "EVOPLAY", "1SPIN4WIN", "SMARTSOFT"];

  const obj = {
    live: live,
    slot: slot,
    table: table,
    fishing: fishing,
    egame: egame,
    crash: crash,
    AWC: awc,
    royal: royal,
  };
  return (
    <>
      <div
        style={{
          paddingTop: "28.8vw",
          background: "rgb(51, 51, 51)",
        }}
        className="subcasino subcasino-new"
      >
        <div
          className="d-flex align-items-start flex-wrap"
          // style={{ padding: subCasinoTrue ? `116px 0px 7px 0.428571rem` : "" }}
        >
          {obj[header]?.map((res) => {
            return (
              <span
                style={{
                  position: "relative",
                }}
                onClick={() => setSubCasino(res)}
                // className={subCasino === res && "active"}
              >
                <p
                  style={{
                    position: "relative",
                    zIndex: "10",
                    color: subCasino == res ? "black" : "white",
                    // padding: "0",
                    // margin: "0",
                    // marginTop: "2px",

                    margin: "2px 0px 0px",
                    padding: "0px 0.4rem",
                    borderRadius: "0.25rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  {res == "KINGMAKER"
                    ? "KINGMIDAS"
                    : res == "RT"
                      ? "REDTIGER"
                      : res}
                </p>
                {subCasino === res && (
                  <motion.div
                    layoutId="pill-tab-casino-top"
                    transition={{ type: "spring", duration: 0.5 }}
                    className="casino-header-slide"
                    // style={{
                    //   position: "absolute",
                    //   inset: "0px",
                    //   zIndex: "0",
                    //   background: "#ffc800",
                    //   color: "black",
                    //   // fontSize: ".9285714285714286rem",
                    //   // borderRadius: ".25rem",
                    //   // height:"1.7142857142857142rem",
                    //   // padding: "0 .4rem ",
                    //   // margin:".1rem .5rem",
                    //   // width:'100%'
                    // }}
                  ></motion.div>
                )}
              </span>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SubCasino;
